module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 163.0f01cf34.png";